/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_ImportInputs */



/**
* | output |
* | --- |
* | "Merge Import" |
*
* @param {Merge_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_import = /** @type {((inputs?: Merge_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner l’import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние Импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マージインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मर्ज आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar Importação")
	return /** @type {LocalizedString} */ ("Merge Import")
});